@let employee = result();

<div
  (click)="openMitarbeiterDetailView(employee)"
  class="relative flex items-center gap-2 w-full cursor-pointer"
>
  <span
    class="flex items-center justify-center rounded-md min-w-8 min-h-8 text-center"
    [ngClass]="{
      'bg-success-200 text-success-700': employee.status === 'A',
      'bg-warning-200 text-warning-700': employee.status === 'E',
      'bg-danger-200 text-danger-700': employee.status === 'U',
      'bg-surface-tertiary text-light':
        employee.status !== 'A' && employee.status !== 'E' && employee.status !== 'U',
    }"
  >
    <span
      class="inline-block w-2.5 h-2.5 rounded-full"
      [ngClass]="{
        'bg-success-500': employee.status === 'A',
        'bg-warning-500': employee.status === 'E',
        'bg-danger-500': employee.status === 'U',
        'bg-gray-400':
          employee.status !== 'A' && employee.status !== 'E' && employee.status !== 'U',
      }"
    ></span>
  </span>
  <div class="flex flex-col w-full text-start truncate">
    <span class="text-sm font-semibold truncate">
      {{ employee.lstfix.vorname }} {{ employee.lstfix.zuname }}
    </span>
    <span class="text-xs text-light truncate">
      {{ employee.lstfix.persnr }}
      @if (employee.abteilung?.bezeichnung) {
        &middot; {{ employee.abteilung.bezeichnung }}
      }
      @if (employee.letzterStempel) {
        &middot; {{ employee.letzterStempel.kzkg === 'K' ? 'Kommt' : 'Geht' }}
        {{ employee.letzterStempel.zeit | date: 'HH:mm' }}
      }
      @if (employee.abwesenheit?.bezeichnung) {
        &middot; {{ employee.abwesenheit.bezeichnung }}
      }
    </span>
  </div>
</div>
